module.exports = __webpack_public_path__ + "img/faq-overlay.c110cbc4.png";